export default function MobileFrame({ children }) {
  return (
    <div className="h-screen w-full flex justify-center">
      <div className="h-full w-full sm:max-w-sm shadow mobile-container flex flex-col">
        {children}
      </div>
    </div>
  );
}
